// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 66 ? "dc112a36" : chunkId) + "." + {"66":"f437b0de63533e91","712":"d7c1f03634aac29a"}[chunkId] + ".js";
};